<template>
  <div id="customerRecordList">
    <div class="customer_records">
      <div>
        <a-list
          itemLayout="vertical"
          :data-source="remindList"
          :pagination="reminderPagination"
          id="customerRemindItems">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <div v-if="!item.isEdit">
              <!-- 显示具体的提醒信息字段 -->
              <div style="display: flex;">
                <div style="flex: 3;">
                  <div class="remind-item-label">{{$t('customer.remindDetail.time')}}</div>
                  <div class="remind-item-value">{{ $utils.formatDate(item.startTime) }}</div>
                </div>
                <div style="flex: 2;">
                  <div class="remind-item-label">{{$t('customer.remindDetail.workRemind')}}</div>
                  <div class="remind-item-value">{{ getWorkLabel(item.advanceDays) }}</div>
                </div>
              </div>

              <div style="margin-top: 15px">
                <div class="remind-item-label">{{$t('customer.remindDetail.theme')}}</div>
                <div class="remind-item-value">{{ item.content }}</div>
              </div>

              <div style="display: flex; justify-content: flex-end;">
                <pt-icon
                  type="icon-bianji1"
                  class="remind-item-icon"
                  style="margin-right: 10px; cursor: pointer;"
                  @click.native="updateRemindEvent(item)"
                ></pt-icon>
                <pt-icon type="icon-tubiao" class="remind-item-icon" @click.native="deleteRemindEvent(item)"></pt-icon>
              </div>
            </div>
            <div class="customer_remind_edit" v-else>
              <!-- 编辑状态的内容 -->
              <a-form-model :model="saveForm" ref="ruleForm" :colon="false">
                <div class="customerFormDiv">
                  <div style="display: flex;">
                    <div style="flex: 3;">
                      <a-form-model-item :label="$t('customer.remindDetail.time')" prop="startTime" class="required"
                                         :rules=" [ {required: true,message: $t('customer.remindDetail.dateTip'),},]">
                        <a-date-picker v-model:value="saveForm.startTime" @change="onChange" :allowClear="false"
                                       :disabled-date="disabledDate" style="width: 67%" :format="dateFormat"
                                       :placeholder="$t('customer.remindDetail.selectTip')" />
                      </a-form-model-item>
                    </div>
                    <div style="flex: 2;">
                      <a-form-model-item :label="$t('customer.remindDetail.workRemind')" prop="advanceDays"
                                         class="required"
                                         :rules=" [ {required: true,message: $t('customer.remindDetail.workTip'),},]">
                        <pt-select v-model="saveForm.advanceDays" :placeholder="$t('customer.remindDetail.selectTip')"
                                   style="width: 100%">
                          <a-select-option
                            v-for="workItem in workList"
                            :key="workItem.value"
                            :value="workItem.value"
                            :disabled="isWorkItemDisabled(workItem)">
                            {{ workItem.label }}
                          </a-select-option>
                        </pt-select>
                      </a-form-model-item>
                    </div>
                  </div>

                  <div>
                    <a-form-model-item prop="content" :label="$t('customer.remindDetail.theme')" class="required"
                                       :rules=" [ {required: true,message: $t('customer.remindDetail.themeTip'),},]">
                      <a-textarea :rows="4" v-model="saveForm.content" :placeholder="$t('key82qingshuru')"
                                  :maxLength="200"></a-textarea>
                    </a-form-model-item>
                  </div>
                </div>
              </a-form-model>
              <div style="display: flex; justify-content: flex-end;">
                <pt-icon type="icon-tijiao" class="remind-item-icon" style="margin-right: 10px;"
                         @click.native="submitEdit(item)" ></pt-icon>
                <pt-icon type="icon-quxiao" class="remind-item-icon" @click.native="cancelEdit(item)"></pt-icon>
              </div>
            </div>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import reminderApi, { deleteRemind } from '@/api/work/reminder'

export default {
  name: 'customerRemindList',
  props: {
    remindList: {
      type: Array,
      default: () => []
    },
    reminderPagination: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  computed: {
    dateDiffDays() {
      if (!this.saveForm.startTime) {
        return 0
      }
      const selectedDate = moment(this.saveForm.startTime).startOf('day')
      const today = moment().startOf('day')
      return selectedDate.diff(today, 'days')
    }
  },
  data() {
    return {
      saveForm: {},
      dateFormat: 'YYYY-MM-DD',
      workList: [
        {
          value: 0,
          label: this.$t('customer.remindDetail.workRemindList.thatDay')
        },
        {
          value: 1,
          label: this.$t('customer.remindDetail.workRemindList.beforeOneDay')
        },
        {
          value: 2,
          label: this.$t('customer.remindDetail.workRemindList.beforeTwoDay')
        },
        {
          value: 3,
          label: this.$t('customer.remindDetail.workRemindList.beforeThreeDay')
        },
        {
          value: 7,
          label: this.$t('customer.remindDetail.workRemindList.beforeOneWeek')
        }
      ]
    }
  },
  methods: {
    getWorkLabel(advanceDays) {
      const item = this.workList.find(x => x.value == advanceDays)
      return item ? item.label : ''
    },

    updateRemindEvent(item) {
      console.log('进入编辑模式', item)
      // 关闭所有其他项的编辑模式
      this.closeAllEditModes()
      // 设置当前项为编辑状态
      this.$set(item, 'isEdit', true)
      // 初始化表单数据
      this.saveForm = {
        ...item,
        startTime: moment(item.startTime)
      }
    },

    // 关闭所有编辑模式
    closeAllEditModes() {
      this.remindList.forEach(listItem => {
        this.$set(listItem, 'isEdit', false)
      })
    },

    // 取消编辑
    cancelEdit(item) {
      console.log('取消编辑', item)
      // 关闭当前项的编辑状态
      this.$set(item, 'isEdit', false)
      // 清空表单数据
      this.saveForm = {}
    },

    // 提交编辑
    submitEdit(item) {
      console.log('提交编辑', this.saveForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          console.log('saveForm::::', this.saveForm)
          reminderApi.insert(this.saveForm).then(res => {
            if (res.code == 1) {
              this.$message.success(res.message)
              // 关闭编辑模式
              this.$set(item, 'isEdit', false)
              this.$emit('flushRemindList')
              this.saveForm = {}
            }
          })
        } else {
          this.$message.warning('请正确输入表单')
        }
      })
    },

    deleteRemindEvent(value){
      let _this = this;
      this.$ptConfirm({
        content:'确定删除?',
        onOk(){
          _this.$loading.show();
          reminderApi.deleteRemind({idList:[value.id]}).then(res => {
            if (res.code == 1) {
              _this.$message.success('删除成功')
              _this.$emit('flushRemindList')
              _this.$loading.hide();
            }
          })
        },
        onCancel(){}
      })
    },

    isWorkItemDisabled(item) {
      if (!this.saveForm.startTime) {
        return false
      }
      return item.value > this.dateDiffDays - 1
    },

    disabledDate(current) {
      return current && current < moment().endOf('day')
    },

    onChange(value, dateString) {
      console.log('选择的时间: ', value)
      console.log('格式化后的时间: ', dateString)
      this.saveForm.startTime = moment(value).startOf('day')
      this.saveForm.advanceDays = undefined
    }
  },
  watch: {
    remindList: {
      handler(list) {
        list.forEach(item => {
          if (!item.hasOwnProperty('isEdit')) {
            this.$set(item, 'isEdit', false)
          }
        })
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.remind-item-label {
  font-size: 12px;
  color: #999999;
  font-weight: 500;
}

.remind-item-value {
  font-size: 12px;
  color: #333333;
  font-weight: 500;
}

.customer_remind_edit /deep/ .ant-form-item-label {
  line-height: 18px !important;
}

.customer_remind_edit /deep/ .ant-form-item-control {
  line-height: 30px !important;
}

.customer_remind_edit /deep/ .ant-form-item {
  margin-bottom: 10px !important;
}
.customer_remind_edit /deep/ .has-error .ant-form-explain {
  font-size: 12px !important;
  margin-top: 2px;
}
</style>
